// client/src/analytics/RouteChangeTracker.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPage } from "./agile";

export default function RouteChangeTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPage();
  }, [location.pathname, location.search, location.hash]);
  return null;
}
